// Utility for appending or updating a query parameter in a URL string
export function appendQueryParamToUrl(
  baseUrl: string,
  key: string,
  value: string | number
): string {
  const url = new URL(baseUrl, window.location.origin)
  url.searchParams.set(key, String(value))
  return url.pathname + url.search
}
